import React from 'react'
import { ErrorBoundary, FallbackProps } from 'react-error-boundary'
import { useLocation } from 'react-router-dom'

import { isFeatureAccessDenied } from '../utils/isFeatureAccessDenied'

import { AccessDeniedPage } from 'views/AccessDeniedPage/AccessDeniedPage'

interface OutletErrorHandlerProps {
  children: React.ReactNode
}

const renderAccessDeniedOrRethrow = ({
  error,
  resetErrorBoundary,
}: FallbackProps) => {
  if (!isFeatureAccessDenied(error)) {
    throw error
  }

  return <AccessDeniedPage resetErrorBoundary={resetErrorBoundary} />
}

export const OutletErrorHandler: React.FC<OutletErrorHandlerProps> = ({
  children,
}) => {
  const location = useLocation()

  return (
    <ErrorBoundary
      fallbackRender={renderAccessDeniedOrRethrow}
      resetKeys={[location.pathname]}
    >
      {children}
    </ErrorBoundary>
  )
}
